// ---------------------------------------------------------------------------
// CompletionStep — Celebration screen shown after session completion
// ---------------------------------------------------------------------------

import { t } from '@/i18n';
import styles from './CompletionStep.module.css';

export function CompletionStep() {

  return (
    <div className={styles['wrapper']} role="status" aria-live="polite">
      {/* Celebration particles */}
      <div className={styles['particles']} aria-hidden="true">
        {Array.from({ length: 12 }).map((_, i) => (
          <span
            key={i}
            className={styles['particle']}
            style={{ '--i': i } as React.CSSProperties}
          />
        ))}
      </div>

      {/* Animated lightning bolt icon */}
      <div className={styles['icon-ring']}>
        <svg className={styles['icon']} viewBox="0 0 52 52" aria-hidden="true">
          <circle className={styles['circle']} cx="26" cy="26" r="24" fill="none" />
          <path
            className={styles['bolt']}
            d="M29 14L19 28h7l-3 10 10-14h-7l3-10z"
            fill="none"
          />
        </svg>
      </div>

      <h2 className={styles['title']}>{t('completion.title')}</h2>
    </div>
  );
}
